<div class="footerplayer">

    <div id="footer_wrapper">
    <footer id="footer">
    <div class="footer-wrapper">
  
        <div *ngIf="audioFile!=''">

            <div class="audiofilename">
                <span class="audiofilename"> {{displayname}}</span>
                <div *ngFor="let file of files; let i = index;"></div>
            </div>
      
            <div class="audioslider" *ngIf="audioFile!=''">
                
                    {{ state?.readableCurrentTime }} 
                        
                        <!-- <span *ngIf="audioFile!=''"> / </span> -->
    
                        <mat-slider class="selector" min="0" [max]="state?.duration" step="1" discrete [displayWith]="formatLabel" [disabled]="state?.error || audioFile === undefined">
                            <input matSliderThumb [value]="state?.currentTime" (input)="onSliderChangeEnd($event)" [disabled]="state?.error || audioFile === undefined" />
                        </mat-slider>
    
                    {{ state?.readableDuration }}
                    
            </div>
  
  
  
            <div class="audiobar" *ngIf="audioFile!=''">
    
                    <!-- skip intro button - if clicked it will skip forward to second 10 of each audio & hide the skip intro button so you don't have to listen to every intro, if you do not click it the skip intro button will still disappear after second 10 because it no longer applies. if you rewind back to the beginning or anywhere before the intro ends, the button will reappear -->
                    
                    <span *ngIf="state?.readableCurrentTime<'0:10'"> 
                        <span class="skipintrobutton">
                            <button mat-stroked-button class="btn btn-skipintro" (click)="skipintro()" onClick="var t = this; setTimeout(function() {t.disabled = true;},1000);">
                                    <span>Skip Intro</span>
                            </button> 
                            <span class="skipintropadd"></span>
                        </span>
                    </span>
    
    

                    <!-- rewind backwards 10 seconds -->
                    <button mat-button (click)="rewind()" class="mat-button">
                        <i class="fa-sharp fa-solid fa-backward"></i>      
                    </button>
    
                    <span class="audiobarbuttons"></span>

                    <!-- toggle mute / unmute buttons -->
                    <button mat-button (click)="setMute(true)" [disabled]="state?.error" *ngIf="!this.mutestate" class="mat-button">
                        <i class="fa-solid fa-volume"></i>
                    </button>
    
                    <button mat-button (click)="setMute(false)" *ngIf="this.mutestate" class="mat-button">
                        <i class="fa-solid fa-volume-slash"></i>
                    </button>
    
                    <span class="audiobarbuttons"></span>
    
                    <!-- toggle play / pause buttons -->
                    <button mat-button (click)="play()" [disabled]="state?.error" *ngIf="!state?.playing" class="mat-button">
                        <i class="fa-solid fa-circle-play"></i>
                    </button>
    
                    <button mat-button (click)="pause()" *ngIf="state?.playing" class="mat-button">
                        <i class="fa-light fa-circle-pause"></i>
                    </button>
    
                    <span class="audiobarbuttons"></span>
                    
                    <!-- fast forward 10 seconds -->
                    <button mat-button (click)="forward()" class="mat-button">
                        <i class="fa-sharp fa-solid fa-forward"></i>
                    </button>
    
                    <div class="audiobarbottom"></div>
            </div>
  
        </div>
  
  </div>
  </footer>
  </div>
  </div>
